import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './HelpCenter.module.css';

const HelpCenter = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.helpCenter}>
      <header className={styles.header}>
        <button
          type="button"
          className={styles.backBtn}
          onClick={() => navigate(-1)}
          aria-label="返回"
        >
          <span className={`material-symbols-outlined ${styles.backIcon}`}>arrow_back</span>
        </button>
        <h1 className={styles.title}>帮助中心</h1>
      </header>

      <div className={styles.card}>
        {/* ── 关于 AI 翻译 ── */}
        <section className={styles.section}>
          <div className={styles.sectionHeader}>
            <div className={`${styles.iconBox} ${styles.iconBoxPurple}`}>
              <span className="material-symbols-outlined">psychology</span>
            </div>
            <h2 className={styles.sectionTitle}>关于 AI 翻译</h2>
          </div>
          <ul className={styles.dotList}>
            <li className={styles.dotItem}>
              <div className={styles.dot} />
              <p>本应用的英文翻译由 AI 自动生成，虽然整体质量较高，但仍存在不完美之处，请大家学习时自行甄别。</p>
            </li>
            <li className={styles.dotItem}>
              <div className={styles.dot} />
              <p>古文用词（如"孤""寡人"等）、人称代词 (he/she) 等场景，AI 有时会判断不准确，这属于正常现象。</p>
            </li>
            <li className={styles.dotItem}>
              <div className={styles.dot} />
              <p>请不要陷入完美主义 —— 作者本人也曾是完美主义者，因此这款软件多打磨了好几个月才与大家见面。如果坚持完美，可能还要更久。</p>
            </li>
            <li className={styles.dotItem}>
              <div className={styles.dot} />
              <p>希望大家互相理解，接纳并拥抱不完美，专注于自己学到了什么。</p>
            </li>
            <li className={styles.dotItem}>
              <div className={styles.dot} />
              <div className={styles.tipBox}>
                <p>如果发现较大的错误（如中英文句子错位、内容不对应等 Bug），欢迎在<span className={styles.highlight}>「个人中心 → 用户反馈」</span>页面提交修正，我们会尽快处理。</p>
              </div>
            </li>
          </ul>
        </section>

        {/* ── 开始阅读 ── */}
        <section className={styles.section}>
          <div className={styles.sectionHeader}>
            <div className={`${styles.iconBox} ${styles.iconBoxBlue}`}>
              <span className="material-symbols-outlined">menu_book</span>
            </div>
            <h2 className={styles.sectionTitle}>开始阅读</h2>
          </div>
          <div className={styles.gridCards}>
            <div className={styles.gridCard}>
              <span className={`material-symbols-outlined ${styles.gridCardIcon}`}>search</span>
              <p>在「发现」或「书架」页面选择一本感兴趣的书籍并进入详情页。</p>
            </div>
            <div className={styles.gridCard}>
              <span className={`material-symbols-outlined ${styles.gridCardIcon}`}>list</span>
              <p>点击章节目录中的任一章节即可进入阅读模式。</p>
            </div>
            <div className={styles.gridCard}>
              <span className={`material-symbols-outlined ${styles.gridCardIcon}`}>bookmark_add</span>
              <p>阅读过程中可收藏单词、句子或添加笔记，方便日后复习。</p>
            </div>
          </div>
        </section>

        {/* ── 收藏与学习 ── */}
        <section className={styles.section}>
          <div className={styles.sectionHeader}>
            <div className={`${styles.iconBox} ${styles.iconBoxAmber}`}>
              <span className="material-symbols-outlined">star</span>
            </div>
            <h2 className={styles.sectionTitle}>收藏与学习</h2>
          </div>
          <div className={styles.rowList}>
            <div className={styles.rowItem}>
              <span className={`material-symbols-outlined ${styles.rowIcon}`}>highlight</span>
              <p>在章节阅读页点击高亮按钮即可收藏当前单词或句子。</p>
            </div>
            <div className={styles.rowItem}>
              <span className={`material-symbols-outlined ${styles.rowIcon}`}>collections_bookmark</span>
              <p>前往「学习中心」或书籍详情页的学习入口，可集中复习已收藏内容。</p>
            </div>
            <div className={styles.rowItem}>
              <span className={`material-symbols-outlined ${styles.rowIcon}`}>settings_suggest</span>
              <p>单词学习支持自动播放、循环次数等个性化设置。</p>
            </div>
          </div>
        </section>

        {/* ── 历史与统计 ── */}
        <section className={styles.section}>
          <div className={styles.sectionHeader}>
            <div className={`${styles.iconBox} ${styles.iconBoxGreen}`}>
              <span className="material-symbols-outlined">bar_chart</span>
            </div>
            <h2 className={styles.sectionTitle}>历史与统计</h2>
          </div>
          <div className={styles.rowList}>
            <div className={styles.rowItemGreen}>
              <span className={`material-symbols-outlined ${styles.rowIconGreen}`}>history</span>
              <p>「个人中心 → 阅读历史」可查看近期阅读与收藏记录。</p>
            </div>
            <div className={styles.rowItemGreen}>
              <span className={`material-symbols-outlined ${styles.rowIconGreen}`}>auto_stories</span>
              <p>章节阅读会自动加入历史，方便快速返回继续阅读。</p>
            </div>
            <div className={styles.rowItemGreen}>
              <span className={`material-symbols-outlined ${styles.rowIconGreen}`}>folder_managed</span>
              <p>收藏的单词和句子均可在历史页或学习页管理、取消收藏。</p>
            </div>
          </div>
        </section>

        {/* ── 常见问题 ── */}
        <section className={styles.sectionLast}>
          <div className={styles.sectionHeader}>
            <div className={`${styles.iconBox} ${styles.iconBoxRed}`}>
              <span className="material-symbols-outlined">help_outline</span>
            </div>
            <h2 className={styles.sectionTitle}>常见问题</h2>
          </div>
          <ul className={styles.dotList}>
            <li className={styles.dotItem}>
              <div className={styles.dot} />
              <p>若遇到加载缓慢，请检查网络连接或稍后重试。</p>
            </li>
            <li className={styles.dotItem}>
              <div className={styles.dot} />
              <p>收藏后没有立即显示，可尝试刷新页面或重新打开学习入口。</p>
            </li>
            <li className={styles.dotItem}>
              <div className={styles.dot} />
              <p>如需反馈问题，欢迎在<span className={styles.highlight}>「个人中心 → 用户反馈」</span>提交。</p>
            </li>
          </ul>
        </section>
      </div>

      <footer className={styles.footer}>
        <p>致力为每位学习者提供优质的英文阅读体验。</p>
      </footer>
    </div>
  );
};

export default HelpCenter;
